import { Controller } from '@hotwired/stimulus'
export default class ShowcaseController extends Controller {
  connect() {
    this.updateSelectionSummary()
    this.updateSaveButtons();
  }

  checkSaleDate(e) {
    if ($(e.target).prop('checked')) {
      $('.end-date-input').removeClass('d-none')
    } else {
      $('.end-date-input').addClass('d-none')
      $('#showcase_sale_end_date').val('')
    }
  }

  checkAddress(e) {
    if ($(e.target).prop('checked')) {
      $('.address-form').addClass('d-none')
      $('[name=user_address_id]').removeClass('ignore_validation')
    }
  }

  checkAddressForm(e) {
    $('.address-form').removeClass('d-none')
    $('[name=user_address_id]').addClass('ignore_validation')
    $('.suggestion-address').each(function (index, element) {
      if ($(element).prop('checked')) {
        $(element).prop('checked', false)
      }
    })
  }

  selectShowcase(e) {
    if (e.target.closest('a')) {
      return;
    }
    $(e.currentTarget).toggleClass('selected-cases')
    this.updateSelectionSummary()
    this.updateSaveButtons();
  }

  selectedShowcaseNumbers() {
    return Array.from(
      this.element.querySelectorAll('.selected-cases[data-number]')
    ).map(item => item.dataset.number)
  }

  updateSelectionSummary() {
    const count = this.selectedShowcaseNumbers().length
    const button = this.element.querySelector('.selected-item-button')
    const label = this.element.querySelector('.selected-item-count')

    button?.classList.toggle('d-none', count === 0)
    if (label) label.textContent = `${count} ${count === 1 ? 'Item' : 'Items'} Selected`
  }

  clearSelection() {
    this.element
      .querySelectorAll('.selected-cases')
      .forEach(item => {
        item.classList.remove('selected-cases');
      });

    this.updateSelectionSummary();
    this.updateSaveButtons();
  }

  async saveItem() {
    const confirmed = await this.confirmBulkAction('save');

    if (!confirmed) {
      return;
    }

    const turboRequest = await this.loadTurboRequest();

    await turboRequest("/shopping_bags/save_showcase", {
      method: 'POST',
      params: {
        showcase_ids: this.selectedShowcaseNumbers()
      },
      turboStream: false,
      onSuccess: () => {
        this.clearSelection();
      }
    });
  }

  async unsaveItem() {
    const confirmed = await this.confirmBulkAction('unsave');

    if (!confirmed) {
      return;
    }

    const turboRequest = await this.loadTurboRequest();

    await turboRequest("/shopping_bags/unsave_showcase", {
      method: 'DELETE',
      params: {
        showcase_ids: this.selectedShowcaseNumbers()
      },
      turboStream: false,
      onSuccess: () => {
        this.clearSelection();
      }
    });
  }

  async buyItem(e) {
    const turboRequest = await this.loadTurboRequest()
    turboRequest('/showcases/multiple_buy_now', {
      method: 'POST',
      params: {
        showcase_ids: this.selectedShowcaseNumbers()
      },
      turboStream: false,
      onSuccess: () => {
        let truck_modal = document.getElementById('shareRecipeScrollModal')
        const modal = bootstrap.Modal.getInstance(truck_modal)
        modal.show()
      }
    })
  }

  changeData(e) {
    let options = $(e.target).closest('.select-container').find('.option')
    const toggle = $(e.currentTarget)
      .closest('.dropdown')
      .find('[data-bs-toggle="dropdown"]')[0]

    options.each((index, e) => {
      if (e.dataset.showcaseOptionBound === 'true') return
      e.dataset.showcaseOptionBound = 'true'

      e.addEventListener('click', (event) => {
        event.stopPropagation()
        const container = e.closest('.select-container')
        const displayLabel = container?.querySelector('[data-showcase-selected-label]')
        const hiddenInput = container?.querySelector('input[type="hidden"]')

        if (displayLabel) {
          const optionLabel = e.querySelector('.filter_by, .sort_by')
          displayLabel.textContent = (optionLabel?.textContent || e.dataset.name)
            .replaceAll(/Price\s*:\s*/gi, '')
            .trim()
        }
        if (hiddenInput) {
          hiddenInput.value = e.dataset.value
          hiddenInput.name = e.dataset.id
        }
        options.removeClass('selected')
        e.classList.add('selected')

        const form = document.getElementById('sort_form')
        this.persistShowcaseFilters(form)
        form.requestSubmit()

        // Close dropdown after selecting an option
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle)
        dropdown?.hide()
      })
    })
  }

  persistShowcaseFilters(form) {
    if (!form) return

    const url = new URL(form.action, globalThis.location.href)
    const search = new URLSearchParams()

    for (const [name, value] of new FormData(form).entries()) {
      if (typeof value === 'string' && value.length > 0) {
        search.append(name, value)
      }
    }

    url.search = search.toString()
    globalThis.history.replaceState(globalThis.history.state, '', url)
  }

  changeTabContent(e) {
    let pane = $('.profile-tab-pane1')
    let sibling = $('.home-tab-pane1')
    if ($(e.currentTarget).attr('id') === 'profile-tab1') {
      sibling.removeClass('show active')
      pane.addClass('show active')
    } else {
      pane.removeClass('show active')
      sibling.addClass('show active')
    }
  }

  hideModel(e) {
    if ($('#shareRecipeScrollModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeScrollModal'))
      modal.hide()
    }

    if ($('#shareRecipeModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
      modal.hide()
    }
  }

  async loadTurboRequest() {
    const turboRequest = (await import("../helpers/api")).turboRequest
    return turboRequest
  }

  updateSaveButtons() {
    const selectedItems = Array.from(
      this.element.querySelectorAll('.selected-cases[data-number]')
    );

    const saveButton = this.element.querySelector('.save-showcase-button');
    const unsaveButton = this.element.querySelector('.unsave-showcase-button');

    if (!selectedItems.length) {
      saveButton?.classList.add('d-none');
      unsaveButton?.classList.add('d-none');
      return;
    }

    const savedItems = selectedItems.filter(
      item => item.dataset.saved === 'true'
    );

    const unsavedItems = selectedItems.filter(
      item => item.dataset.saved !== 'true'
    );

    if (savedItems.length === selectedItems.length) {
      saveButton?.classList.add('d-none');
      unsaveButton?.classList.remove('d-none');
      return;
    }

    if (unsavedItems.length === selectedItems.length) {
      saveButton?.classList.remove('d-none');
      unsaveButton?.classList.add('d-none');
      return;
    }

    saveButton?.classList.remove('d-none');
    unsaveButton?.classList.remove('d-none');
  }

  async confirmBulkAction(action) {
    const count = this.selectedShowcaseNumbers().length;

    if (!count) {
      return false;
    }

    const confirmed = await confirmation(
      `Are you sure you want to ${action === 'save' ? 'save' : 'unsave'
      } the ${count} selected item${count === 1 ? '' : 's'}?`,
      'OK'
    );

    return confirmed;
  }
}
